const moment = require('moment');

export default function formatDate(value: any, formatString: string) {
    return value
        ? moment.utc(value).utcOffset(7 * 60).format(formatString ? formatString : 'DD-MM-YYYY HH:mm:ss')
        : '';
}
